import { useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { Container, Spinner, Card, Row, Col } from 'react-bootstrap'
import Navbar from './Navbar'
import defaultImg from '../Assets/Assests/BannerImg.jpg'

const PodcastPlayer = () => {
  const location = useLocation()
  const { details } = location.state || {}
  const [loading, setLoading] = useState(true)
  const [audioLoading, setAudioLoading] = useState(true)

  useEffect(() => {
    if (details) {
      setLoading(false)
    }
  }, [details])

  if (loading) {
    return (
      <div className='d-flex justify-content-center align-items-center vh-100'>
        <Spinner animation='border' variant='primary' />
      </div>
    )
  }

  if (!details)
    return (
      <p className='text-center text-muted'>No podcast details available</p>
    )

  return (
    <>
      <Navbar />
      <Container className='mt-5 p-4 bg-white rounded-4 shadow-lg'>
        <Row className='align-items-center'>
          <Col md={5} className='text-center'>
            <Card.Img
              src={details.banner_image_url || defaultImg}
              alt='Podcast Cover'
              className='img-fluid rounded'
              style={{ maxHeight: '350px' }}
            />
          </Col>
          <Col md={7}>
            <h2 className='text-primary'>{details.topic}</h2>
            {/* <h5 className='text-muted'>
              {details.name} - {details.profession}
            </h5>
            <p>
              <strong>Designation:</strong> {details.designation}
            </p>
            <p>
              <strong>Qualification:</strong> {details.qualification}
            </p>
            <p>
              <strong>Experience:</strong> {details.experience} years
            </p>
            <p>
              <strong>Company Address:</strong> {details.company_address}
            </p>
            <p>
              <strong>Expertise:</strong> {details.expertise}
            </p> */}
          </Col>
        </Row>
        {/* Audio Loader Spinner */}
        {audioLoading && (
          <div className='d-flex justify-content-center align-items-center mt-4'>
            <Spinner animation='border' variant='secondary' role='status' />
            <span className='ms-2 text-muted'>Loading audio...</span>
          </div>
        )}

        {/* Audio Player */}
        <audio
          controls
          controlsList='nodownload'
          className={`mt-4 w-100 ${audioLoading ? 'd-none' : 'd-block'}`}
          onCanPlayThrough={() => setAudioLoading(false)}
          onError={() => setAudioLoading(false)}
        >
          <source src={details.path_url} type='audio/mpeg' />
          Your browser does not support the audio element.
        </audio>
      </Container>
    </>
  )
}

export default PodcastPlayer
